import {DRAWER_WIDTH} from "../launcher-style-consts";

export const getDrawerWidth = () => {
    if(window.innerWidth < 1280){
        return 0;
    }
    return DRAWER_WIDTH;
};